import { TextBadge } from '@/UIlibrary/TextBadge/TextBadge';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';

const calculatedValues = [
	'totalIncome',
	'totalHouseExpenses',
	'totalBusinessExpenses',
	'totalValueOfAssets',
	'CalculatedMonthlyNetIncome'
];

const QuestionnaireInput: React.FC<{
	title: string;
	value: string;
}> = ({ title, value }) => {
	const t = useTranslations('VanCreditRequestQuestionnaire');
	return (
		<div
			className={`flex flex-row justify-between ${calculatedValues.includes(title) ? 'border-b-2' : ''}`}
		>
			<Typography size="sm" weight="medium">
				{t(toTranslationKey(title))}:
			</Typography>
			{value !== '' ? (
				value === null ? (
					<TextBadge text={t('Optionals')} size="sm" type="gray" />
				) : (
					<Typography
						size="md"
						weight="semibold"
						color={calculatedValues.includes(title) ? 'black' : '#8C8C8C'}
					>
						{value}
					</Typography>
				)
			) : (
				<Typography size="md" weight="semibold" color="#8C8C8C">
					-
				</Typography>
			)}
		</div>
	);
};

export default QuestionnaireInput;
